import { useCallback, useState } from 'react';
var DndSortable = function (_a) {
    var onDragOver = _a.onDragOver, onDrop = _a.onDrop, children = _a.children;
    var _b = useState(null), draggedElement = _b[0], setDraggedElement = _b[1];
    var onDragBegin = useCallback(function (id, position) {
        return setDraggedElement({ id: id, initialPosition: position });
    }, []);
    var onDragEnd = useCallback(function () { return setDraggedElement(null); }, []);
    var onDropHandler = useCallback(function (position) {
        if (draggedElement !== null &&
            position !== null &&
            draggedElement.initialPosition !== position) {
            onDrop && onDrop(draggedElement.id, position);
        }
    }, [draggedElement, onDrop]);
    var onHoverHandler = useCallback(function (position) {
        if (draggedElement !== null) {
            onDragOver && onDragOver(draggedElement.id, position);
        }
    }, [draggedElement, onDragOver]);
    return children({
        onDragBegin: onDragBegin,
        onDragEnd: onDragEnd,
        onHover: onHoverHandler,
        onDrop: onDropHandler,
        draggedElementId: draggedElement ? draggedElement.id : null,
    });
};
DndSortable.displayName = 'DndSortable';
export default DndSortable;
//# sourceMappingURL=DndSortable.js.map